import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex h-10 items-center", { animate: _ctx.animate, infinite: _ctx.infinite }]),
    onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startAnimation && _ctx.startAnimation(...args)))
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(["inline-block h-full", 
        _ctx.variant === 'light'
          ? 'fill-brand-400 stroke-brand-300'
          : 'fill-brand-500 stroke-brand-600'
      ]),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 200 200"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("g", null, [
        _createElementVNode("circle", {
          class: "orbit",
          style: {"fill":"none","stroke-width":"7"},
          cx: "100",
          cy: "100",
          r: "80"
        }),
        _createElementVNode("circle", {
          class: "planet",
          style: {"stroke":"none","stroke-width":"0"},
          cx: "100",
          cy: "100",
          r: "50"
        }),
        _createElementVNode("circle", {
          class: "moon",
          style: {"stroke":"none","stroke-width":"0"},
          cx: "100",
          cy: "100",
          r: "20"
        })
      ], -1)
    ]))], 2)),
    (_ctx.withText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["ml-2 align-middle text-xl font-bold", _ctx.variant === 'light' ? 'text-white' : 'text-brand-600'])
        }, " Himalia ", 2))
      : _createCommentVNode("", true)
  ], 34))
}